import { connect } from 'react-redux'

import ClientsPerAgentsComponent from './component'
import { getClientsPerAgent, clearReportV2Phase } from '../../../../../../store/reportV2/duck'

const ClientsPerAgentsContainer = connect(
  // Map state to props
  (state) => ({
    clientsPerAgentsPhase: state.reportV2.clientsPerAgentsPhase,
    clientsPerAgentsData: state.reportV2.clientsPerAgentsData
  }),
  // Map actions to dispatch and props
  {
    getClientsPerAgent,
    clearReportV2Phase
  }
)(ClientsPerAgentsComponent)

export default ClientsPerAgentsContainer
